import { ReactNode } from 'react';

export type PollInterval = number | false;

export interface DashboardTab {
  key: string;
  label: string;
  render: (interval: PollInterval) => ReactNode;
}

// One area of the dashboard, owning its own tabs. Add a section by adding an
// entry to sections/index.ts — nothing else needs to know about it.
export interface DashboardSection {
  key: string;
  label: string;
  tabs: DashboardTab[];
}

export const POLL_OPTIONS: { label: string; value: PollInterval }[] = [
  { label: 'Off', value: false },
  { label: '2s', value: 2000 },
  { label: '10s', value: 10000 },
  { label: '30s', value: 30000 },
  { label: '1m', value: 60000 },
  { label: '5m', value: 300000 }
];

// Off by default: opening the dashboard should cost one round of reads, not a
// standing load on the broker. Engineers opt in per visit.
export const DEFAULT_POLL_INTERVAL: PollInterval = false;
